import * as core from '../../../../../../../core'

import { query } from './asset-organization-table.query'

export const RESOURCE = {
  payload: {
    alias: 'asset.organization.table',
    description:
      'Expandable table that shows number of assets for each level of organization',
    name: 'Asset Organization Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
